import { useContext } from "react";

import { Divider, MenuItem } from "@material-ui/core";
import { CloudDownload } from "@material-ui/icons";

import LessonPlansTable from "./LessonPlans/GroupedLessonPlan";
import AddNewLessonPlanModal from "./Modal/AddPlan";
import { Button } from "./Component";

import { GlobalContext } from "../../context/GlobalState";
import {
  useLessonPlans,
} from "../../context/LessonPlanProvider";

function LessonPlansContent() {
  
  const { userDetails, assignedGrades } = useContext(GlobalContext);
  const {
    loading,
    grades,
    exporting,
    filterObjects,
    filterSubjects,
    filteredPlans,
    setLessonPlans,
    selectedGrades,
    selectedTeacher,
    filterDateObject,
    setSelectedTeacher,
    selectGrade,
    selectSubject,
    handleDateChange,
    clearFilter,
    exportLessonPlans,
    lessonPlans,
    groupedPlans
  } = useLessonPlans();

  document.title = "2xcell.in";

  return (
    <section className="taskList">
      <div className="mx-2 my-5 m-lg-5">
        <div className="row">
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              marginBottom: "20px",
            }}
          >
            <h1 style={{ margin: "0" }}>Lesson Plans</h1>
            {userDetails?.role === "teacher" ? (
              <Button style={{ marginLeft: "auto" }}>
                <MenuItem
                  data-bs-toggle="modal"
                  data-bs-target="#resourceModal"
                  value="url"
                  style={{
                    fontFamily: "Poppins",
                    margin: "0px",
                    padding: "0px",
                    height: "fit-content",
                    minHeight: "fit-content",
                  }}
                >
                  Create Lesson Plan
                </MenuItem>
              </Button>
            ) : (
              <Button onClick={exportLessonPlans} style={{ marginLeft: "auto" }}>
                <CloudDownload />
                {exporting ? "Exporting":"Export"}
              </Button>
            )}
          </div>

          {/* Filters */}
          {filterObjects?.grades.length ? (
            <div className="col-sm-2 mb-2">
              <div className="reportCardFilter border rounded">
                <h4 className="px-3 py-2">Filters</h4>
                <Divider className="filterDivider" variant="fullWidth" />

                {filterObjects?.teachers?.length ? (
                  <div className="class px-3 mt-2 lp-input">
                    <p style={{ margin: 0, fontWeight: "bold", color: "#4fb8ad" }}>
                      TEACHERS
                    </p>
                    <select
                      className="select"
                      onChange={(e) => setSelectedTeacher(e.target.value || "")}
                      value={selectedTeacher || ""}
                    >
                      <option key={0} value={""}>
                        Select Teacher
                      </option>
                      {filterObjects.teachers.map((item, index) => (
                        <option key={index} value={item.value}>
                          {item.name}
                        </option>
                      ))}
                    </select>
                  </div>
                ) : null}

                {/* Grades */}
                <div className="class px-3 mt-2 lp-input">
                  <p style={{ margin: 0, fontWeight: "bold", color: "#4fb8ad" }}>
                    GRADES
                  </p>
                  {filterObjects?.grades && (
                    <select
                      className="select"
                      value={Object.keys(selectedGrades)[0] || ""}
                      onChange={selectGrade}
                    >
                      <option key={0} value={""}>
                        Select Grade
                      </option>
                      {filterObjects.grades.map((item, index) => (
                        <option key={index} value={item.value}>
                          {item.name}
                        </option>
                      ))}
                    </select>
                  )}
                </div>

                {/* Subjects */}
                {filterSubjects.length ? (
                  <div className="subjects px-3 mt-2 lp-input">
                    <p style={{ margin: 0, fontWeight: "bold", color: "#4fb8ad" }}>
                      SUBJECT
                    </p>
                    <select className="select" onChange={selectSubject}>
                      <option key={0} value={""}>
                        Select Subject
                      </option>
                      {filterSubjects.map((item, index) => (
                        <option
                          key={index}
                          value={`${item.sectionId}-${item.value}`}
                          selected={selectedGrades[item.sectionId]?.includes(item.value)}
                        >
                          {item.name}
                        </option>
                      ))}
                    </select>
                  </div>
                ) : null}

                {/* Dates */}
                <div className="subjects px-3 mt-2 lp-input">
                  <p style={{ margin: 0, fontWeight: "bold", color: "#4fb8ad" }}>
                    From Date
                  </p>
                  <input
                    name="fromDate"
                    type="date"
                    value={filterDateObject.fromDate || ""}
                    onChange={handleDateChange}
                  />
                </div>
                <div className="subjects px-3 mt-2 lp-input">
                  <p style={{ margin: 0, fontWeight: "bold", color: "#4fb8ad" }}>
                    To Date
                  </p>
                  <input
                    name="toDate"
                    type="date"
                    value={filterDateObject.toDate || ""}
                    onChange={handleDateChange}
                  />
                </div>

                {/* Clear */}
                <div
                  style={{
                    width: "calc(100% - 24px)",
                    height: "35px",
                    margin: "20px 12px",
                    borderRadius: "5px",
                    display: "flex",
                    alignItems: "center",
                    fontSize: "0.9rem",
                    justifyContent: "center",
                    border: "2px solid #4fb8ad",
                    cursor: "pointer",
                    color: "#4fb8ad",
                  }}
                  onClick={clearFilter}
                >
                  <span style={{ display: "block" }}>Clear Filter</span>
                </div>
              </div>
            </div>
          ) : null}

          {/* Table */}
          <LessonPlansTable
            staffRole={userDetails?.role || ""}
            loading={loading}
            grades={filterObjects.grades.length}
            lessonPlans={filteredPlans}
            groupedPlans={groupedPlans}
            filterDateObject={filterDateObject}
            handleDateChange={handleDateChange}
            setLessonPlans={setLessonPlans}
            clearFilter={clearFilter}
          />

          {/* Modal */}
          <AddNewLessonPlanModal
            userId={userDetails.userId}
            assignedClasses={assignedGrades.grades}
            grades={grades}
            lessonPlans={lessonPlans}
            setLessonPlans={setLessonPlans}
          />
        </div>
      </div>
    </section>
  );
}

export default LessonPlansContent;
